import { Injectable, Testability } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { SecurityService } from './security.service';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { $TRAIL, FEATURE_DISCOVERY } from 'core/services/assets/constants';

@Injectable()
export class TrailService {
  private $trail: any;
  public featureDiscoverySubject = new BehaviorSubject(null);

  constructor(private securityService: SecurityService, private testability: Testability) {}

  initializeTrail(route: ActivatedRouteSnapshot): Observable<any> {
    const queryParams = route ? route.queryParams : {};
    const rawTrail = queryParams[$TRAIL];
    if (!rawTrail) {
      this.$trail = {};
      return of(this.$trail);
    }
    return this.securityService.validateClientJwtToken(rawTrail).pipe(
      switchMap((payload) => {
        this.$trail = payload;
        if (this.$trail[FEATURE_DISCOVERY]) {
          this.testability.whenStable(() => {
            this.featureDiscoverySubject.next(this.$trail[FEATURE_DISCOVERY]);
          });
        }
        return of(this.$trail);
      }),
      catchError((error) => {
        console.error(error);
        this.$trail = {};
        return of(this.$trail);
      })
    );
  }

  getTrailFor(name) {
    return name && this.$trail && this.$trail[name] ? this.$trail[name] : {};
  }

  public getFeatureDiscovery$(): Observable<any> {
    return this.featureDiscoverySubject.asObservable();
  }
}
